// src/utils/handleError.js
export function handleApiError(
    error,
    fallbackMessage = "Something went wrong!",
) {
    if (error.response && error.response.data) {
        return (
            error?.response?.data?.message ||
            error?.response?.data?.detail ||
            fallbackMessage
        );
    } else if (error.request) {
        return "No response from server. Please check your network.";
    } else {
        return fallbackMessage;
    }
}
